module.exports = __webpack_public_path__ + "img/wuliuapp.d50130c8.png";